// Measurement → normalized metrics → Health Score → diagnosis. Pure; no DOM or network access.
import { diagnose, type Diagnosis } from './diagnosis/diagnose';
import { missingCoreMetrics, normalize, type NormalizedMetrics } from './measurement/normalize';
import { MeasurementError, type RawMeasurementResult } from './measurement/types';
import { scoreMetrics, type HealthScore } from './scoring/score';

export interface Analysis {
  metrics: NormalizedMetrics;
  health: HealthScore;
  diagnosis: Diagnosis;
  /** Approximate data transferred by the check, in bytes. */
  dataUsedBytes: number;
}

export function analyze(raw: RawMeasurementResult): Analysis {
  const metrics = normalize(raw);
  const missing = missingCoreMetrics(metrics);
  const health = scoreMetrics(metrics);
  if (missing.length || !health) {
    throw new MeasurementError('incomplete', `Missing measurements: ${missing.join(', ')}`, 'analyzing', { metrics });
  }
  return {
    metrics,
    health,
    diagnosis: diagnose(metrics, health),
    dataUsedBytes: raw.engine.downloadBytes + raw.upload.bytesSent,
  };
}
